import { connect } from 'react-redux';
import { selectors } from '../../../root/reading/root';
import LinkWrapper from '../../../features/navigation/LinkWrapper';
import { switchPeriod } from '../../../api/periods/shared/periodsActions';
import {
    selectIndividualStudent,
    downloadStudentActivity,
    sortStudentByName,
} from '../../../api/lrs/shared/lrsActions';
import { toyTabs } from '../../../utils/shared/navigationUtils';
import switchDualLanguageGrade from '../../../api/dualLanguage/dualLanguageActions';
import DualLanguage from '../../../features/dualLanguage/DualLanguage';
import { fetchAdditionalStudentResults } from '../../../api/results/reading/resultActions';
import { fetchAdditionalEnrollmentData } from '../../../api/enrollment/reading/enrollmentActions';
import { BASE_URLS } from '../../../constants/reading/ApiConstants';
import { getUrlParams } from '../../../utils/shared/urlUtils';
import { PERIOD } from '../../../constants/shared/CommonConstants';

const mapStateToProps = state => {
    const location = selectors.getLocation(state);
    const params = getUrlParams(location);
    const isSummerPeriodPresent = selectors.getToyPeriods(state).includes(PERIOD.SUMMER);
    return {
        studentsData: selectors.getDualLanguageStudentsData(state),
        selectedPeriod: selectors.getSelectedPeriodWithoutSummary(state),
        selectedGrade: selectors.getSelectedDualLanguageGrade(state),
        grades: selectors.getGradesInCurrentClass(state),
        currentPeriod: selectors.getCurrentPeriod(state),
        isAdditionalResultsFetched: selectors.isAdditionalResultsFetched(state),
        isAdditionalEnrollmentInfoFetched: selectors.isAdditionalEnrollmentDataFetched(state),
        toyTabs: toyTabs(
            location,
            BASE_URLS.DUAL_LANGUAGE_URL,
            {
                burstGroupUid: params.burstGroupUid,
            },
            isSummerPeriodPresent,

            selectors.getSummerPeriodLabel(state),
        ),
        licensingInfo: selectors.getDualLanguageLicensingInfo(state),
        LinkWrapper,
    };
};

const mapDispatchToProps = dispatch => ({
    switchGrade: grade => {
        dispatch(switchDualLanguageGrade(grade));
    },
    switchPeriod: (period, studentId) => {
        dispatch(switchPeriod(period, studentId));
    },
    fetchAdditionalStudentResults: () => {
        dispatch(fetchAdditionalStudentResults());
    },
    fetchAdditionalEnrollmentData: () => {
        dispatch(fetchAdditionalEnrollmentData());
    },
    selectStudent: id => {
        dispatch(selectIndividualStudent(id));
    },
    downloadStudentActivity: (activityName, instructionalActivityId, selectedStudentId) => {
        dispatch(downloadStudentActivity(activityName, instructionalActivityId, selectedStudentId));
    },
    sortStudents: sortDirection => {
        dispatch(sortStudentByName(sortDirection));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(DualLanguage);
